import React, { useState } from "react";
import TopNavigation from "../../layouts/top-navigation/TopNavigation";
import RegisterTable from "./RegistrationTable/RegisterTable";
import RoleTable from "./RegistrationTable/RoleTable";
import RegisterSidebar from "./RegistrationTable/RegisterSidebar";

const Register = () => {
  const [active, setActive] = useState<string>("/registertable");

  const [data, setData] = useState(0);
  const [dataUser, setDataUser] = useState(0);

  return (
    <div id="screen-wrapper">
      <TopNavigation />
      <RegisterSidebar setActive={setActive} active={undefined} />
      <main>
        <div>

          {active === "/registertable" && (
            <RegisterTable
              pageHeader={"Register User"}
              headerTitles={[]}
              setData={setData}
            />
          )}

          {active === "/roletable" && (
            <RoleTable pageHeader={"User Role"} setDataUser={setDataUser} />
          )}
        </div>
      </main>
    </div>
  );
};

export default Register;
